<template>
  <v-select
    v-model="emailSenderId"
    :items="enrichedEmailSenders"
    label="Campaign From"
    item-text="selectSummary"
    item-value="id"
    :error-messages="errorMessages"
    :disable="disabled"
    no-data-text="No rooftop selected -or- rooftop has no Email Senders"
  ></v-select>
</template>

<script>
import { EmailSenderApi } from '@/services'

export default {
  name: 'email-sender-select',
  props: {
    value: {
      type: [Number, String],
      required: false,
      default: null
    },
    dealer_id: {
      type: [Number, String],
      required: false,
      default: null
    },
    rooftop_id: {
      type: [Number, String],
      required: false,
      default: null
    },
    errorMessages: {
      type: Array
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      emailSenders: []
    }
  },
  computed: {
    emailSenderId: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    enrichedEmailSenders () {
      return this.emailSenders
        .map(sender => {
          sender.selectSummary = `${sender.name} <${sender.email}> ${sender.job_title}`
          return sender
        })
    }
  },
  watch: {
    dealer_id: {
      immediate: true,
      handler: function (newVal, oldVal) {
        this.fetchEmailSenders()
      }
    },
    rooftop_id: {
      immediate: true,
      handler: function (newVal, oldVal) {
        this.fetchEmailSenders()
      }
    }
  },
  mounted: function () {
    this.fetchEmailSenders()
  },
  methods: {
    async fetchEmailSenders (clearExistingSenderId) {
      try {
        if (this.dealer_id && this.rooftop_id) {
          this.emailSenders = (await EmailSenderApi.fetchSenders({
            dealerId: this.dealer_id,
            rooftopId: this.rooftop_id
          })).data
          // if existing sender id is not in the list of fetched senders, clear it
          if (this.value) {
            const existingSenderId = this.value
            const existingSender = this.emailSenders.find(sender => sender.id === existingSenderId)
            if (!existingSender) {
              this.$emit('input', null)
            }
          }
        } else {
          this.$logger.trace('Skipping Email Sender Fetch - no dealer_id and/or rooftop_id')
        }
      } catch (error) {
        this.$logger.error('Error fetching EmailSenders', error.message)
        this.$flash({
          showClose: true,
          message: `Error fetching EmailSenders. ${error.message}`,
          type: 'error',
          duration: 0
        })
      }
    }
  }
}
</script>
